<app-header-content-footer *transloco="let t"
  [headerTitle]="t('add-points')">
  <app-sidenav-content content>
    <app-points-rescue content></app-points-rescue>
  </app-sidenav-content>
</app-header-content-footer> 
